import { TranslationModel } from '@/core/domain/translation/models/translation.model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export type TranslationState = TranslationModel;

export const selectTranslation =
    createFeatureSelector<TranslationModel>('translations');

export const selectTranslationState = createSelector(
    selectTranslation,
    (state: TranslationState) => state['translations'],
);
